const pageNameKey = "ticketPatchUtilitiesContainer";

export const ticketPatchUtilitiesContainerEn = {
  [pageNameKey]: {
    machineLabel: "Machine",
    saveButton: "Save",
    sourcePlaceholder: "Select a machine",
    noSourcesFound: "No machines found",
    assigneeLabel: "Assignee",
    requestedBy: "Requested By",
    via: "Via",
    remoteMachineLabel: "Remote Machine HMI Access",
    noFirmwareInformation: "No firmware information",
    noCompanyInformation: "No company information",
    noMachineInformation: "No machine information",
    noMachineIdInformation: "No machine ID information",
    noMachineIPInformation: "No machine IP information",
    noUserInformation: "No user information",
    unknown: "Unknown",
    companyAltText: "Company icon",
    sourceIconAltText: "Source icon",
    closing: "Closing",
    machineNotAvailable: "Machine is currently unavailable.",
  },
};

export const ticketPatchUtilitiesContainerPtBr = {
  [pageNameKey]: {
    machineLabel: "Máquina",
    saveButton: "Salvar",
    sourcePlaceholder: "Selecione uma máquina",
    noSourcesFound: "Nenhuma máquina encontrada",
    assigneeLabel: "Responsável",
    requestedBy: "Solicitado por",
    via: "Via",
    remoteMachineLabel: "Acesso remoto à HMI da máquina",
    noFirmwareInformation: "Nenhuma informação de firmware",
    noCompanyInformation: "Nenhuma informação da empresa",
    noMachineInformation: "Nenhuma informação da máquina",
    noMachineIdInformation: "Nenhuma informação de ID de máquina",
    noMachineIPInformation: "Nenhuma informação de IP da máquina",
    noUserInformation: "Nenhuma informação do usuário",
    unknown: "Desconhecido",
    companyAltText: "Ícone da empresa",
    sourceIconAltText: "Ícone da fonte",
    closing: "Fechando",
    machineNotAvailable: "Máquina não está disponível no momento.",
  },
};

export const ticketPatchUtilitiesContainerDe = {
  [pageNameKey]: {
    machineLabel: "Maschine",
    saveButton: "Speichern",
    sourcePlaceholder: "Maschine auswählen",
    noSourcesFound: "Keine Maschinen gefunden",
    assigneeLabel: "Beauftragter",
    requestedBy: "Angefragt von",
    via: "Über",
    remoteMachineLabel: "Remote-Zugriff auf die Maschinen-HMI",
    noFirmwareInformation: "Keine Firmware-Informationen",
    noCompanyInformation: "Keine Unternehmensinformationen",
    noMachineInformation: "Keine Maschineninformationen",
    noMachineIdInformation: "Keine Maschinen-ID-Informationen",
    noMachineIPInformation: "Keine Maschinen-IP-Informationen",
    noUserInformation: "Keine Benutzerinformationen",
    unknown: "Unbekannt",
    companyAltText: "Firmenicon",
    sourceIconAltText: "Quellenicon",
    closing: "Schließt",
    machineNotAvailable: "Die Maschine ist derzeit nicht verfügbar.",
  },
};

export const ticketPatchUtilitiesContainerZhHans = {
  [pageNameKey]: {
    machineLabel: "机器",
    saveButton: "保存",
    sourcePlaceholder: "选择机器",
    noSourcesFound: "未找到机器",
    assigneeLabel: "受让人",
    requestedBy: "请求者",
    via: "通过",
    remoteMachineLabel: "远程机器HMI访问",
    noFirmwareInformation: "没有固件信息",
    noCompanyInformation: "没有公司信息",
    noMachineInformation: "没有机器信息",
    noMachineIdInformation: "没有机器ID信息",
    noMachineIPInformation: "没有机器IP信息",
    noUserInformation: "没有用户信息",
    unknown: "未知",
    companyAltText: "公司图标",
    sourceIconAltText: "来源图标",
    closing: "正在关闭",
    machineNotAvailable: "机器当前不可用。",
  },
};

export const ticketPatchUtilitiesContainerIt = {
  [pageNameKey]: {
    machineLabel: "Macchina",
    saveButton: "Salva",
    sourcePlaceholder: "Seleziona una macchina",
    noSourcesFound: "Nessuna macchina trovata",
    assigneeLabel: "Assegnatario",
    requestedBy: "Richiesto da",
    via: "Via",
    remoteMachineLabel: "Accesso remoto alla macchina HMI",
    noFirmwareInformation: "Nessuna informazione sul firmware",
    noCompanyInformation: "Nessuna informazione sull'azienda",
    noMachineInformation: "Nessuna informazione sulla macchina",
    noMachineIdInformation: "Nessuna informazione sull'ID macchina",
    noMachineIPInformation: "Nessuna informazione IP della macchina",
    noUserInformation: "Nessuna informazione sull'utente",
    unknown: "Sconosciuto",
    companyAltText: "Icona aziendale",
    sourceIconAltText: "Icona sorgente",
    closing: "Chiusura",
    machineNotAvailable: "Macchina non disponibile al momento.",
  },
};

export const ticketPatchUtilitiesContainerEs = {
  [pageNameKey]: {
    machineLabel: "Máquina",
    saveButton: "Guardar",
    sourcePlaceholder: "Selecciona una máquina",
    noSourcesFound: "No se encontraron máquinas",
    assigneeLabel: "Asignado a",
    requestedBy: "Solicitado por",
    via: "A través de",
    remoteMachineLabel: "Acceso remoto a la máquina HMI",
    noFirmwareInformation: "No hay información de firmware",
    noCompanyInformation: "No hay información de la empresa",
    noMachineInformation: "No hay información de la máquina",
    noMachineIdInformation: "No hay información del ID de la máquina",
    noMachineIPInformation: "No hay información de IP de la máquina",
    noUserInformation: "No hay información del usuario",
    unknown: "Desconocido",
    companyAltText: "Icono de la empresa",
    sourceIconAltText: "Icono de origen",
    closing: "Cerrando",
    machineNotAvailable: "La máquina no está disponible actualmente.",
  },
};

export const ticketPatchUtilitiesContainerNl = {
  [pageNameKey]: {
    machineLabel: "Machine",
    saveButton: "Opslaan",
    sourcePlaceholder: "Selecteer een machine",
    noSourcesFound: "Geen machines gevonden",
    assigneeLabel: "Toegewezen aan",
    requestedBy: "Aangevraagd door",
    via: "Via",
    remoteMachineLabel: "Extern toegang tot de HMI van de machine",
    noFirmwareInformation: "Geen firmware-informatie",
    noCompanyInformation: "Geen bedrijfsinformatie",
    noMachineInformation: "Geen machine-informatie",
    noMachineIdInformation: "Geen machine-ID-informatie",
    noMachineIPInformation: "Geen machine-IP-informatie",
    noUserInformation: "Geen gebruikersinformatie",
    unknown: "Onbekend",
    companyAltText: "Bedrijfsicoon",
    sourceIconAltText: "Bronicoon",
    closing: "Sluiten",
    machineNotAvailable: "De machine is momenteel niet beschikbaar.",
  },
};

export const ticketPatchUtilitiesContainerTr = {
  [pageNameKey]: {
    machineLabel: "Makine",
    saveButton: "Kaydet",
    sourcePlaceholder: "Makine seçin",
    noSourcesFound: "Makine bulunamadı",
    assigneeLabel: "Vekil",
    closing: "Kapanış",
    companyAltText: "Şirket simgesi",
    machineNotAvailable: "Makine şu anda kullanılamıyor.",
    noCompanyInformation: "Şirket bilgisi yok",
    noFirmwareInformation: "Firmware bilgisi yok",
    noMachineIPInformation: "Makine IP bilgisi yok",
    noMachineIdInformation: "Makine kimliği bilgisi yok",
    noMachineInformation: "Makine bilgisi yok",
    noUserInformation: "Kullanıcı bilgisi yok",
    remoteMachineLabel: "Uzak Makine HMI Erişimi",
    requestedBy: "İsteyen",
    sourceIconAltText: "Kaynak simgesi",
    unknown: "Bilinmiyor",
    via: "Aracılığıyla",
  },
};
